import React, { useRef } from "react";

const FLOW_IMPORT_FILE_INPUT_ID = "flow-import-file-input";

export const triggerFlowImport = () => {
  const input = document.getElementById(FLOW_IMPORT_FILE_INPUT_ID) as HTMLInputElement;
  input?.click();
};

export interface FlowImportFileInputProps {
  onFileSelect: (content: string | undefined) => void;
}

export const FlowImportFileInput: React.FC<FlowImportFileInputProps> = ({ onFileSelect }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.readAsText(file, "UTF-8");

    reader.onload = (readerEvent) => {
      const result = readerEvent.target?.result;
      const content = typeof result === "string" ? result : undefined;
      onFileSelect(content);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    };

    reader.onerror = (errorEvent) => {
      const error = errorEvent.target?.error;
      console.error("Error reading file", error);
      onFileSelect(undefined);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    };
  };

  return (
    <input
      ref={inputRef}
      type="file"
      id={FLOW_IMPORT_FILE_INPUT_ID}
      accept=".txt,.json"
      style={{ display: "none" }}
      onChange={handleChange}
    />
  );
};
